import Vue from 'vue';
import App from './App';
import VueResource from 'vue-resource';
import router from './routes';
import Navbar from './components/Navbar';
import Links from './components/Navbar.links';
import BlogCarousel from './components/Blog.carousel';
import Testimonials from './components/Testimonials.carousel';
import Footer from './components/Footer';
import CallToAction from './components/CallToAction';
import SolutionItem from './components/Item.solution';

Vue.config.productionTip = false;
Vue.use(VueResource);

Vue.component('navbar', Navbar);
Vue.component('nav-links', Links);
Vue.component('blog-carousel', BlogCarousel);
Vue.component('testimonials-carousel', Testimonials);
Vue.component('end-footer', Footer);
Vue.component('call-action', CallToAction);
Vue.component('solution-item', SolutionItem);

new Vue({
  el: '#app',
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js